import { render, staticRenderFns } from "./StepConfirm.vue?vue&type=template&id=d2770412"
import script from "./StepConfirm.vue?vue&type=script&lang=js"
export * from "./StepConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports